/*
* BookingsService used for getting information about bookings.
*/

import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { HttpService } from '../http/http.service';
import { Observable, of } from 'rxjs';
import { map, publishReplay, refCount, tap } from 'rxjs/operators';
import { Booking } from '@models/booking';

@Injectable({
    providedIn: 'root'
})

export class BookingsService {

    public bookings: Booking[] | null;

    constructor(
        public baseService: BaseService,
        public httpService: HttpService
    ) { }

    /*
    * Fetch bookings from the API and parse data
    */
    public get(): Observable<Booking[]> {
        if (!this.bookings) {
            return this.httpService.get('/bookings').pipe(
                map((response: any) => {
                    this.bookings = response.data;
                    return response.data;
                }),
                publishReplay(1),
                refCount());
        }
        return of(this.bookings);
    }

    /*
    * Get booking by either by id or boooking code from the API
    */
    public getById(id: string, isPreview: boolean): Observable<Booking> {
        return this.httpService.get((isPreview) ? `/bookings/preview/${id}` : `/bookings/${id}`).pipe(
            map((response: any) => {
                return response.data
            }));
    }

    /*
    * Post bookings to Api and updates datastore.
    */
    public post(body: any, isPreview?: boolean, code?: string): Observable<Booking> {
        return this.httpService.post((isPreview) ? `/bookings/preview/${code}` : `/bookings`, body).pipe(
            map((response: any) => response.data), tap(() => {
                this.bookings = null;
            }));
    }
}